/* pushAffordance.js — Pure visibility decision for PushEnablementRow.
 *
 * Kept module-level so it's trivially unit-testable without rendering
 * React. The component reads this to decide what (if anything) to show.
 */

/**
 * decidePushAffordance(state)
 * @param {object} state
 * @param {boolean} state.supported  - browser supports push
 * @param {boolean} state.serverOn   - server has VAPID configured
 * @param {"default"|"granted"|"denied"|"unsupported"} state.permission
 * @param {boolean} state.subscribed - active subscription on this device
 * @param {boolean} state.dismissed  - session-dismissed
 * @param {boolean} state.declined   - persistently declined (localStorage)
 * @returns {"hidden"|"idle"|"enabled"}
 */
export const decidePushAffordance = ({
  supported,
  serverOn,
  permission,
  subscribed,
  dismissed,
  declined,
}) => {
  if (!supported || !serverOn) return "hidden";
  if (permission === "denied") return "hidden";
  // Permission granted + active sub → show the calm "enabled" confirmation.
  if (permission === "granted" && subscribed) return "enabled";
  // Permission granted but no subscription → defer (silent resubscribe
  // is in-flight from authStore). Don't flash an Enable CTA.
  if (permission === "granted" && !subscribed) return "hidden";
  // Default permission, but the user dismissed/declined earlier → respect that.
  if (dismissed || declined) return "hidden";
  return "idle";
};
